import React, { Component} from 'react'
import { Helmet } from "react-helmet"

import {
		Table,
		Popup,
		Button,
		Divider,
		Icon,
		Container,
		Segment,
		Header,
		Message,
		Modal,
		Confirm,
		Checkbox, 
	} from 'semantic-ui-react'

import { ObjectInspector, chromeLight } from 'react-inspector';

import API_service from 'xAppLib/providers/API_service'
import obj_2_arr from 'xAppLib/helpers/obj_2_arr'

import user_model from 'models/user_model'

import game_model from 'models/game_model'

import {DataConnector, DataShow, ListFilters, ListPagination, ListTable} from 'xAppLib/DataTable'
import {ViewEditDets} from 'xAppLib/DataList'

import Leaderboard from 'views/leaderboard/Leaderboard'

// import InnerScriptsList from 'views/scripts/modules/InnerScriptsList'
// import ActBtns from 'views/UIelems/fields/ActBtns'
// import scripts_list_model from "../../../models/scripts_list_model";

const WrapComponent = ({embedded, children, hdr}) => {
	return embedded ? <div>{children}</div> : 
						<Container className='wide-content' fluid>
							<Helmet>
								<title>{hdr}</title>
							</Helmet>
							<h1>{hdr}</h1>
							{children}
						</Container>
}

export default class GamesAdmin extends Component {

	constructor (props) {
		super(props)

		// user_model.limit_access('admin');
		// user_model.limit_access('games');

		const { show_list } = props.match&&props.match.params||props

		this.state = {
			filters:{
				hide_user_referral:true,
				hide_org_referral:true,
				...this.props.filters
			},
			pageSize:props.pageSize && props.pageSize || 50,
			page:1,
			show_list,
			scripts_toggle:{},
		}
		
	}


	//	------------------------	------------------------	------------------------

	componentDidMount () {
		this.setState(GamesAdmin.set_list_params(this.props))

		this.load_games()
	}

	//	------------------------	------------------------	------------------------

	componentDidUpdate(prevProps) {
		if (this.props.use_data !== prevProps.use_data) {
			this.load_games()
		}
	}

	//	------------------------	------------------------	------------------------

	async load_games() {

		const result = await game_model.get_record(null, null, {use_data:this.props.use_data, add_id:'gid', add_enum:'gnum', ord_by:'tm', ord_dir:'desc'});

		const res_arr = (this.props.use_data == 'FRDB' ? obj_2_arr(result, 'gid', 'gnum') : result);

		console.log('loaded result', result, res_arr);

		this.setState({games_list_data: res_arr})
		// this.setState({games_list_data: { data: res_arr, total: res_arr.length}})
	}

	//	------------------------	------------------------	------------------------
	//	------------------------	------------------------	------------------------

	static set_list_params (props) {

		// const { show_list } = props.match&&props.match.params||props
		// let hdr, flds
		let list

		// if(app.user?.claims?.doc)
		//     list = { 
		// 		hdr: 'View My Prescribed',
		// 		flds: game_model.LIST_FLDS_DOC,
		// 		// edit_flds: game_model.EDIT_FLDS_DOC,
		// 	} 
		// else if(app.user?.claims?.admin || app.user?.claims?.supp)
			list = { 
				hdr: 'View All Games',
				flds: game_model.LIST_FLDS_ADMIN,
				edit_flds: game_model.EDIT_FLDS_ADMIN,
			}
		// else
		// 	list = { 
		// 		hdr: 'View your organisation games',
		// 		flds: game_model.LIST_FLDS_ORG,
		// 		edit_flds: game_model.EDIT_FLDS_ORG
		// 	}
		return list;

	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------
	
	get is_admin() {
		return app.user?.claims?.admin
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	get is_doc() {
		return app.user?.claims?.doc
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	get is_supp() {
		return app.user?.claims?.supp
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static getDerivedStateFromProps(props, state) {

		return GamesAdmin.set_list_params(props)
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	act = async (a, p) => { 

		return await API_service.load_data( a, p ) 
	}
	
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	onFilterChange = (selection) => { 
		const { filters } = this.state
		if (!selection)
			this.setState({filters:{}}) // wipe
		else 
			this.setState({filters:{...filters,...selection}})
	}
	
	// 		--------------------------------		--------------------------------		---------
	
	
	getData = async (filters, page, pageSize)=>{
		const { show_list } = this.state
		
			// const result = await game_model.get_record();
			const result = await game_model.get_batch_records(null, pageSize, null, true);

			const res_arr = obj_2_arr(result, 'gid', 'gnum')

			// const result = await game_model.load_games({
			// 														filters, 
			// 														limit: pageSize,
			// 														offset: (page-1) * pageSize,
			// 														get_stats: true,
			// 														total_count: true,
			// 													})

			// result?.games?.map( p => p.med__mid = p?.med?.mid )
			// result?.games?.map( p => p.dets__msg = p?.dets?.msg )
			// result?.games?.map( p => p.dets__cost = p?.dets?.cost )
			// result?.games?.map( p => p.doc__doc_id = p?.doc?.doc_id )
			// result?.games?.map( p => p.ref__sid = p?.ref?.sid )

			// result?.games?.map( p => p.show_row_warning = ['annul', 'used'].includes(p.status) )
			// result?.games?.map( p => p.show_row_error = ['cancel'].includes(p.status) || p.enabled!=undefined&&!p.enabled )
			// result?.games?.map( p => p.show_row_disabled = p.enabled!=undefined&&!p.enabled )

			console.log('loaded result', result, res_arr);

			if (res_arr){
				return { data: res_arr, total: res_arr.length }
			}
			return null

	}
	
	handleRef = node => {
		node && this.setState({ buttonNewDiscount:node.ref })
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	async save_presc (prid, d) {

		this.setState({save_presc_status: this.is_admin ? `Sending request for ${d.code || 'new code'}` : "Saving"})
		
		const data = { 
			...d,
			// users:d.users && {email:d.users},
			// meds:d.meds && {include:d.meds},
			// max_use:d.max_use === '' ? null : d.max_use
			dets: {msg:d.dets__msg, cost:d.dets__cost},
			med: {mid:d.med__mid},

			doc: {doc_id:d.doc__doc_id},
			ref: {sid:d.ref__sid},
		}

		console.log('save_presc', data);

		await game_model.save_presc( prid, data, r=>{this.setState({save_presc_status: r});this.setState({refresh:new Date().getTime()});} )
		
	}
	
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------


	async save_presc_fld (prid, fl, vl) {

		this.setState({save_presc_status: this.is_admin ? `Sending save field request for ${fl || 'fld'} : ${vl || 'val'}` : "Saving field"})
		
		console.log('save_presc_fld', prid, fl, vl);

		return await game_model.save_presc_fld( prid, fl, vl, r=>{this.setState({save_presc_status: r});this.setState({refresh:new Date().getTime()});} )
		
	}
	
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	async presc_action (prid, act) {

		this.setState({save_presc_status: this.is_admin ? `Running action ${act}` : "Saving"})

		const result = await game_model.get_record( null, null, {act, prid});

		this.setState({save_presc_status: result});
		this.setState({refresh:new Date().getTime()});

		return result;
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	edit_presc_render() {
		
		const {  save_presc_status, openEditDiscount, buttonNewDiscount, editData, editMode = 'popup' } = this.state
		
		const prid = editData&&editData.prid
		
		let data = {}
		
		if (editData) {
			data = {
				...editData,
				// expiry_date : editData.expiry_date && moment(editData.expiry_date).format('YYYY-MM-DD'),
				// users :  editData.users && editData.users.email,
				// meds :  editData.med.mid
			}
		}

		// console.log('edit_presc_render', editData, data);
		
		const editControl = <ViewEditDets 
				newRecord = {true}

				itm_data = {data} 
				
				onChange={(name,value,values) => {
					if (name=='type') {
						return {
							conf : {...game_model.BASE_CONF, ...(game_model.TYPES[value].conf)}
						}
					}
					
				}}

				det_fields = {this.state.edit_flds}
				onSave_dets = { (d, ca) => {
					
					this.save_presc(prid,d, ca)
				} }

				btn_submit = {
						<Button primary fluid content='Save'  />
					}

				btn_cancel = {
						<span></span>
					}
			/>

		const summary = save_presc_status && save_presc_status.res=='ok' && `SUCCESS - Prescription saved`
							|| save_presc_status && save_presc_status.res=='err' && `ERROR - ${save_presc_status.err_msg}`
							|| save_presc_status ||
							false
							
		let header = editData && "Edit Prescription" || "New Prescription"
	
		return <div style={{marginBottom:'20px'}}>
				

				{editMode == 'popup' && 
					<Popup
							context={buttonNewDiscount}
							open={openEditDiscount} 
							flowing
							basic
							position='bottom left'
							style={{width: '600px'}}
						>
						<Popup.Header>
							{header}
							<Icon link name='close' style={{float:'right'}} onClick={_=>this.setState({openEditDiscount:false})} />
						</Popup.Header>
						<Popup.Content className='add-user'>
							
							{editControl}

							{summary && <Message
								error = {save_presc_status && save_presc_status.res=='err'}
								success = {save_presc_status && save_presc_status.res=='ok'}
								header = { summary }
							 />			}				
						</Popup.Content>
					</Popup> 
				}
				{editMode == 'modal' && 
					<Modal
							open={openEditDiscount} 
							onClose={_=>this.setState({openEditDiscount:false})}
							closeIcon
						>
						<Header>{header}</Header>
						<Modal.Content>
							
							{editControl}

							{summary && <Message
								error = {save_presc_status && save_presc_status.res=='err'}
								success = {save_presc_status && save_presc_status.res=='ok'}
								header = { summary }
							 />	}				
						</Modal.Content>
					</Modal> 
				}
		

		</div>
	}
		
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------
	
	render () {

		const { show_list, games_list_data } = this.state

		const { filters, page,refresh,pageSize } = this.state

		const {embedded = false} = this.props

		return (
			<WrapComponent embedded={embedded} hdr={this.state.hdr}>
				{/*{games_list_data && */}
					<DataConnector
						pageSize={pageSize}
						page={page}
						filters={filters}
						refresh={refresh}
						data_params={show_list}
						data={ games_list_data }
						// data={ this.getData }
						debounceFilters={1000}
						>
						{(data, loading, pages, total, pageSize) => {
							return <React.Fragment>
								{
									<>
									{!this.is_doc && !this.is_supp && <Button 
										ref={this.handleRef} 
										icon  
										compact 
										size={"big"} 
										color="green" 
										onClick={_=>this.setState({openEditDiscount:true,save_presc_status:null,editData:null,editMode:'popup'})}>
											<Icon name='plus' /> Add Prescription
								</Button>}
								{this.edit_presc_render()}
								{!embedded && (this.is_admin || this.is_supp) && <React.Fragment>
									<ListFilters popup selected={this.state.filters} onReset={_=>this.onFilterChange(null)}>
										<Segment.Group horizontal>

											<Segment  color='green'>
												<Header>Prescription / Patient / Type / Status</Header>
												<ListFilters.Filter 
														as="text"
														placeholder="Filter text"
														onFilterChange={ this.onFilterChange }
														name="filter_text"
														value={this.state.filters['filter_text']}
														fluid
													/>
											</Segment>

										</Segment.Group>
									</ListFilters>

									<Button
										content={'Reload List'}
										icon="refresh"
										onClick={_=>this.setState({refresh:new Date().getTime()})}
										color="grey"
										type="button"
										loading={loading}
										style={{marginLeft: 'auto',display:'block'}}
									 />
								</React.Fragment>}

								<ListPagination 
										page={page} 
										pages={pages} 
										pageSize={pageSize}
										loading={loading} 
										data={data} 
										total={total} 
										boundaryRange={3}
										showPageSizeSelector={true}
										onPageSizeChange={pageSize=>this.setState({pageSize})}
										onPageChange={page=>this.setState({page})}/>
									</>
								}
								

								<ListTable data={data} loading={loading} rowKey={row => row.prid}>
									{(row,index)=>{
										const toggle_key = `${index}_${index}`
										return <React.Fragment>

											{this.is_admin && <ListTable.Cell row={row} index={index} label=''>
												{(value,row,index)=>
													<Icon name={this.state.scripts_toggle[toggle_key]?'triangle down':'triangle right'} 
														  onClick={_=>{ this.setState({scripts_toggle:{...this.state.scripts_toggle,[toggle_key]:!this.state.scripts_toggle[toggle_key]}}) }} 
														  />
													}
											</ListTable.Cell>}


											{
												this.state.flds && this.state.flds.map((f, fi)=><ListTable.Cell singleLine row={row} index={index} key={fi} f={f} />)
											}

											
											
											{/*
											<ListTable.Cell 
													// visible={!this.is_supp} 
													row={row} index={index} label='Act btns'
												>
													{(value,row,index)=>(<React.Fragment>

														<ActBtns 
															row={row} 
															f={{
																	name: 'Status',
																	btns_list_func: (row) => {
																		const isScheduled = row.status === 'scheduled';
																		const canBeScheduled = !!row.activate_at;
																		const isTreatmentPlan = !!row.ref?.tpid;
																		const action_btns = isScheduled ? [
																			{t: 'separator'},
																			{n: 'Activate Now', c: 'green', i: 'send', a: 'act:activate'}
																		] : [];

																		const admin_btns = [
																			canBeScheduled && {n:'Scheduled', a:'scheduled', c:'blue', i:''},
																			{n:'Active', a:'active', c:'green', i:''},
																			{n:'Used', a:'used', c:'yellow', i:''},
																			{n:'Annul', a:'annul', c:'orange', i:''},
																			{n:'Cancel', a:'cancel', c:'red', i:''},
																			isTreatmentPlan && {n:'Pending', a:'pending', c:'grey', i:''},
																			...action_btns,
																		].filter(x=>x);

																		const doc_btns = [
																			{n:'Cancel', a:'cancel', c:'red', i:''},
																			...action_btns,
																		];

																		return this.is_doc ? doc_btns : admin_btns;
																	},

																	btns_stat_param: 'status',
																	btns_stat_dict: (stat) => {

																			if (['done_doccall'].includes(stat))	return 'Consult finished';

																			return stat==null ? 'not set' : stat
																		},

																	// btns_stat_dd_opts: SCRIPT_STATUS_OPTIONS,
																	act_run: async (b, row, mod) => {
																		const [type, action] = b.a.split(':');
																		if (type === 'act') {
																			return this.presc_action(row.prid, action);
																		}
																		return this.save_presc_fld(row.prid, 'status', b.a)
																	},

																}}
															/>
														
													</React.Fragment>)}
											</ListTable.Cell>

											<ListTable.Cell 
													visible={!app.acl.is_doc}
													row={row} index={index} label='Actions'
												>
													{(value,row,index)=>(<React.Fragment>

														<Checkbox	
															defaultChecked = {row.enabled}
															onChange = { (e, d) => this.save_presc_fld(row.prid, 'enabled', d.checked) }
															// onChange = { (e, d) => console.log(d.checked) }
															toggle
															style = {{padding:0,alignSelf:'center'}} 
															key = {row.prid}
														/>
														<ActBtns row={row} f={{
															btns_list_func: () => {
																return [
																	{
																		n: 'Edit', i: 'edit', a: _ => {
																			this.setState({openEditDiscount:true,save_presc_status:null,editData:row,editMode:'modal'})
																		}
																	},
																	{
																		n: 'Delete', i: 'x', c: 'red', a: _ => {
																			this.setState({openDeleteDiscount: row.prid})
																		}
																	},
																	['req_icanncons_flup', 'req_doccons_flup'].includes(row.type) && row.status === 'active' && {
																		n: 'Resend Pts Cons Followup Email',
																		i: 'clipboard check',
																		a: {
																			email_type: 'cre_followup_consult',
																			name: 'Patient Followup Email'
																		}
																	},
																	['presc_icann', 'presc_ihair'].includes(row.type) && row.status === 'active' && {
																		n: `Resend Pts Med Presc'd Email`,
																		i: 'pills',
																		a: {
																			email_type: 'scr_pts_presc',
																			name: `Pts Med Presc'd Email`
																		}
																	}
																].filter(Boolean);
															},
															act_run: async (btn, row) => {
																if (btn.a instanceof Function) {
																	return btn.a();
																}
																const {email_type, name} = btn.a;
																const res = await API_service.load_data('games', {
																	act: 'resend_email',
																	email_type,
																	prid: row.prid
																})
																app.trigger(app.events.SHOW_MESSAGE,
																	'Prescriptions Admin',
																	res.res === 'ok' && `Re Sent ${name} :: ${res.to}` || `ERROR Re Sending ${name} :: ${res.to} -- ${res.err}`,
																	res.res === 'ok' && 'positive' || 'negative'
																);
																return res;
															}
														}}/>
													</React.Fragment>)}
											</ListTable.Cell>
											*/}

											<ListTable.Cell 
													// visible={user_model.check_access('admin')} 
													row={row} index={index} label='Raw'
												>
													{(value,row,index)=>(<Popup
															trigger={<Button icon='plus' size="mini" />}
															position='left center'
															on='click'
															style={{height: '80%', width: '80%', minWidth: 700, overflow: 'scroll'}}
													>
														<ObjectInspector
																data={ row }
																expandLevel={ 1 }
																theme={{...chromeLight, ...({ TREENODE_PADDING_LEFT: 20 })}}
															 />
													</Popup>)}
											</ListTable.Cell>


										</React.Fragment>
									}}
									
									{
										(row,index)=>{
										const toggle_key = `${index}_${index}`
										
										if (!user_model.check_access('scripts_list') || !this.state.scripts_toggle[toggle_key])
											return null
										
										return <React.Fragment>
											<Table.Cell colSpan={12}>
												<Leaderboard gid={ row.gid } type='admin' />
											</Table.Cell>
										</React.Fragment>
									}}
								</ListTable>
								<ListPagination 
										page={page} 
										pages={pages} 
										pageSize={pageSize}
										loading={loading} 
										data={data} 
										total={total} 
										boundaryRange={3}
										showPageSizeSelector={true}
										onPageSizeChange={pageSize=>this.setState({pageSize})}
										onPageChange={page=>this.setState({page})}/>
							</React.Fragment>
						}}
						


					</DataConnector>
				{/*}*/}

					<Confirm
						header='Delete presc code'
						open={!!this.state.openDeleteDiscount}
						onCancel={_=>this.setState({openDeleteDiscount:false})}
						onConfirm={async _=>{
							await game_model.delete_presc(this.state.openDeleteDiscount)
							this.setState({openDeleteDiscount:false,refresh:new Date().getTime()})
						}}
					/>
			</WrapComponent>
		)
	}

//	------------------------	------------------------	------------------------
//	------------------------	------------------------	------------------------

}
